import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { UserProvider } from './UserContext';
import { ToastProvider } from './Common/ToastContext';
import ReportBug from './ReportBug';
import ErrorBanner from './ErrorBanner';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <UserProvider>
    <BrowserRouter>
      <ToastProvider>
        <ErrorBanner />
        <ReportBug />
        <App />
      </ToastProvider>
    </BrowserRouter>
  </UserProvider>
  // </React.StrictMode>
);

reportWebVitals();


